import { Topbar, TopbarActions } from '@twilio-paste/core/topbar';

import { UserMenuActions } from '../UserMenuActions';

interface TopBarProperties {
  id: string;
}

export function TopBar({ id }: TopBarProperties) {
  return (
    <Topbar id={id}>
      <TopbarActions justify="end">
        <UserMenuActions />
      </TopbarActions>
    </Topbar>
  );
}
